import { EmptyValue } from "@/molecules/ChipsCell"

export const ValueCell = (value: string) => value || <EmptyValue />
